// import backgroundImg from '../assets/marriagelayout.png';

const viewEventStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },

    homeBackgroundImgContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      // marginTop: theme.spacing(0.5), //commented after live event
      backgroundImage: 'linear-gradient(to right, #3a6186 , #89253e)', //commented after live event
      // background:
      //   'linear-gradient(90deg, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)', //commented to put graduation img
      minHeight: 200,
      borderRadius: 2,
    },
    imgTitleContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      transform: 'translate(0px,20%)',
      width: '100%',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    homeBackgroundImgCls: {
      opacity: 0.6, //0.8
      maxHeight: 200,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(0.2),
    },
    image: {
      maxHeight: 140,
      width: theme.spacing(12),
      height: theme.spacing(12),
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(2),
    },
    titleContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      color: '#fff',
      paddingLeft: theme.spacing(2),
    },
    dateTimeCont: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
    },
    date: {
      marginRight: theme.spacing(0.5),
    },
    statusContainer: {
      justifySelf: 'flex-end',
    },
    activeClass: {
      color: '#fff',
    },
    detailsCont: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
    bodyContnSyle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      width: '100%',
    },
    fourItemCont: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    twoItemCont: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      paddingRight: theme.spacing(2),
    },
    bodyCont: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    layoutImg: {
      objectFit: 'cover',
      width: '100%',
      borderRadius: 5,
    },
    layoutImgCont: {
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      overflow: 'hidden',
    },
    head: {
      fontWeight: 500,
      color: '#a9a9a9',
    },
    actualBody: {
      textAlign: 'justify',
      overflowWrap: 'anywhere',
    },
    actionsCont: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3),
      flexWrap: 'wrap',
    },
    dummy: { flex: 1 },
    secndSetActionsCont: {},
    endEventBtn: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      color: '#90103B',
      borderWidth: theme.spacing(0.2),

      '&:hover': {
        color: '#00acc1',
      },
    },
    titleNstatus: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'baseline', //comment this if need to affect margintop on active icon
      flexWrap: 'wrap',
      width: '100%',
    },
    statusCont: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    activIcon: {
      color: 'red',
      fill: '#008000',
      fontSize: '1rem',
      marginRight: theme.spacing(0.4),
    },
    expiredIcon: {
      color: 'red',
      fill: 'red',
      fontSize: '1rem',
      marginRight: theme.spacing(0.4),
    },
    shareIconCls: {
      fontSize: 18,
      fill: '#fff',
    },
    editEventBtn: {
      margin: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000', //#229954
      '&:hover': {
        backgroundColor: '#008000', //#68B162
        borderColor: '#00acc1',
      },
    },
    mainBody: {
      width: '100%',
    },
    titleStyle: {
      textTransform: 'capitalize',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1rem',
      },
    },
    inputStyles: {
      width: 160,
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: theme.spacing(1),
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
    },
    btnStyleJoin: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    arrowIcon: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
  };
};

export default viewEventStyles;
